export default __webpack_public_path__ + "static/media/icon-water-drop.4683adbc.svg";